import React from 'react';
import { useParams } from 'react-router-dom';
import FornitoriTable from '../components/fornitoriTable';

function Fornitori() {
  const { id } = useParams();
  return (
    <div>
      <FornitoriTable cantiereId={id} />
    </div>
  );
}

export default Fornitori;
